var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2227 2.16675H7.77932C5.47182 2.16675 3.59766 4.05175 3.59766 6.34841V21.6126C3.59766 23.5626 4.99516 24.3859 6.70682 23.4434L11.9935 20.5076C12.5568 20.1934 13.4668 20.1934 14.0193 20.5076L19.306 23.4434C21.0177 24.3967 22.4152 23.5734 22.4152 21.6126V6.34841C22.4043 4.05175 20.5302 2.16675 18.2227 2.16675ZM16.2618 10.5626C15.211 10.9417 14.106 11.1367 13.001 11.1367C11.896 11.1367 10.791 10.9417 9.74016 10.5626C9.31766 10.4109 9.10099 9.94508 9.25266 9.52258C9.41516 9.10008 9.88099 8.88342 10.3035 9.03508C12.0477 9.66341 13.9652 9.66341 15.7093 9.03508C16.1318 8.88342 16.5977 9.10008 16.7493 9.52258C16.901 9.94508 16.6843 10.4109 16.2618 10.5626Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.c75f1a87b1ad49bafa30c9513459cf76.svg";
export { ForwardRef as ReactComponent };